import React from 'react';
import PropTypes from 'prop-types';

const VerificationStatusRejected = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M40 80C39.626 80 39.252 79.9256 38.9007 79.771C37.552 79.2042 6 65.4244 6 37.2692V13.3448L40.9067 1.53557e-08C45.9936 1.73518 74 13.3448 74 13.3448V37.2692C74 65.4244 42.448 79.2042 41.0993 79.7767C40.748 79.9256 40.374 80 40 80Z"
      fill="#FE6B6B"
    />
    <path
      d="M59 39C59 29.0589 50.7173 21 40.5 21C30.2827 21 22 29.0589 22 39C22 48.9411 30.2827 57 40.5 57C50.7173 57 59 48.9411 59 39Z"
      fill="white"
      stroke="white"
    />
    <path
      d="M46.75 33L34 45.75"
      stroke="#FFB5B5"
      strokeWidth="4"
      strokeLinecap="square"
    />
    <path
      d="M46.75 45.75L34 33"
      stroke="#FFB5B5"
      strokeWidth="4"
      strokeLinecap="square"
    />
  </svg>
);

VerificationStatusRejected.propTypes = {
  size: PropTypes.number,
};

export default VerificationStatusRejected;
